module.exports = __webpack_public_path__ + "img/banner-04.e0c03987.jpg";